export const CONFIG = {
  IMAGE_SRC: '//s3.marpple.co/files/u_2798351/2025/7/original/4c10979d97a3a50a1cc2e3f324aa0158f3ed570c1.png',
  IMAGE_ALT: '조각스티커',
};
